import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "footer" }
const _hoisted_2 = { class: "left-container" }
const _hoisted_3 = { class: "version" }
const _hoisted_4 = { class: "right-container" }
const _hoisted_5 = { class: "nav-options" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "nav-option",
        onClick: $setup.supportLink
      }, "Contact Us"),
      _createElementVNode("div", _hoisted_3, _toDisplayString($setup.versionString), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["nav-option faq", { 'active-route': _ctx.$route.path === '/faq' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goToLocation('/faq')))
        }, "FAQ", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["nav-option privacy", { 'active-route': _ctx.$route.path === '/privacy-policy' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goToLocation('/privacy-policy')))
        }, "Privacy Policy / Terms of Use", 2)
      ])
    ])
  ]))
}